/**
 * The day lines and the faces of `ThreadLog`, in a module of their own so the component file exports
 * only components (the fast-refresh lint rule) and the wording can be tested without a screen.
 */

const weekdayAndDate = new Intl.DateTimeFormat("sv-SE", { weekday: "long", day: "numeric", month: "long" });
const fullDate = new Intl.DateTimeFormat("sv-SE", { day: "numeric", month: "long", year: "numeric" });

export function dayKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

/** The day line in the reader's words. Exported for the tests that pin the wording. */
export function dayLabel(date: Date, now: Date = new Date()): string {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const that = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const days = Math.round((today.getTime() - that.getTime()) / 86_400_000);

  if (days === 0) {
    return "I dag";
  }
  if (days === 1) {
    return "I går";
  }
  const label = days > 0 && days < 180 ? weekdayAndDate.format(date) : fullDate.format(date);
  return label.charAt(0).toUpperCase() + label.slice(1);
}

/** Two letters for a face, from a name that can be missing. */
export function initialsOf(name: string | null | undefined): string {
  if (!name) {
    return "?";
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return "?";
  }
  const first = parts[0].charAt(0);
  const second = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return `${first}${second}`.toUpperCase();
}
